import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#156879',
      light: '#94EDFD',
      dark: '#0C0033',
      contrastText: '#FFFFFF',
      error: 'red'
    }
  },
  typography: {
    fontFamily: ['Source Sans Pro']
  },
  borderColor: 'rgba(0, 0, 0, 0.12)',
  overrides: {
   MuiButton: {
     root: {
       textTransform: 'none',
     },
   },
 },
});

export default theme



// WEBPACK FOOTER //
// ./src/theme.js